import React from "react";
import { TableSide, FormBuilder } from "@loanbossinc/component-library";

export const AccordionSection = ({ rows, data, eventHandlers }) => <TableSide rows={rows} data={data} eventHandlers={eventHandlers} />;

export const AccordionEditSection = ({ data, rows, onSubmit, isSaving, isCanceling, onCancel, finishSave, configItems, saveOrderChange, eventHandlers }) => (
  <FormBuilder
    className="d-flex f-1 flex-column"
    rows={rows}
    data={data}
    configItems={configItems}
    initialValues={data}
    onSubmit={onSubmit}
    isSaving={isSaving}
    isCanceling={isCanceling}
    onCancel={onCancel}
    finishSave={finishSave}
    saveOrderChange={saveOrderChange}
    eventHandlers={eventHandlers}
  />
);
